'use client';
import { Dialog, DialogTrigger } from '@vs-shop/ui/dialog';
import { useMemo, useState } from 'react';

import ProductFavouritesButton from './ProductFavouritesButton';
import ProductFavouritesModalContent from './ProductFavouritesModalContent';

import { getFavouriteListsWithProductCodesAtom } from '@vs-shop/engine/atom/favourites/getFavouriteListsWithProductCodesAtom';
import * as AsyncResult from 'effect/unstable/reactivity/AsyncResult';
import { useAtomValue } from '@effect/atom-react';

type Props = {
  variant: 'card' | 'detail';
  productCode: string;
  productName: string;
  isFavouriteInitial: boolean;
};

export default function ProductFavouritesModalInteractive({
  variant,
  productCode,
  productName,
  isFavouriteInitial,
}: Props) {
  const [isOpen, setIsOpen] = useState(true);
  const lists = useAtomValue(getFavouriteListsWithProductCodesAtom);
  const isLoading = lists.waiting;

  const { listsData, isFavourite } = useMemo(() => {
    return AsyncResult.match(lists, {
      onInitial: () => ({
        listsData: [],
        isFavourite: isFavouriteInitial,
      }),
      onFailure: () => ({
        listsData: [],
        isFavourite: isFavouriteInitial,
      }),
      onSuccess: (l) => ({
        listsData: l.value,
        isFavourite: l.value.some(
          (list) => list.productVariantCodes?.includes(productCode) ?? false
        ),
      }),
    });
  }, [lists, productCode, isFavouriteInitial]);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger
        render={<ProductFavouritesButton variant={variant} isFavourite={isFavourite} />}
      />

      {isOpen && (
        <ProductFavouritesModalContent
          productCode={productCode}
          productName={productName}
          listsData={listsData}
          isLoading={isLoading}
          isFavourite={isFavourite}
          onCloseAction={() => {
            setIsOpen(false);
          }}
        />
      )}
    </Dialog>
  );
}
